import React, { useState, useEffect } from "react";
import Pathnames from "../model/enum/Pathnames";
import {
  Spinner,
  Contacts,
  Requests,
  Navbar,
  Appointments,
  Services,
  Overview,
  Clients,
  Gallery,
  Reviews,
  Login,
  Faqs,
  Errors,
  Logs,
  Users,
  UserProfile,
  OverviewTeam,
  Projects,
  ActivationAccount,
  Roles,
  Sidebar,
  Dashboard,
  Estimates,
  DeniedAccess,
  OverviewTag,
  Settings,
  Permissions,
} from "./index";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { SearchProvider } from "../shared/components/search/SearchContext";
import Permission from "../model/permission";
import "./Admin.css";

const customStyles = {
  maxWidth: "2200px", // Set a max width for larger screens
};

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  let pathname = location.pathname;

  const allowedPaths = (): boolean => {
    return (
      pathname !== Pathnames.LOGIN &&
      pathname !== Pathnames.ACTIVATE_ACCOUNT &&
      pathname.includes("admin")
    );
  };

  const checkPathPermission = (path: string): boolean => {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
    // Example logic: deny access if user lacks 'admin_access' permission

    if (!permissions || permissions.length === 0) return false;

    switch (path) {
      case Pathnames.DASHBOARD:
        if (!permissions.some((p: Permission) => p.name === "DASHBOARD"))
          return false;
        break;
      case Pathnames.GALLERY_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Gallery"))
          return false;
        break;
      case Pathnames.REVIEWS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Reviews"))
          return false;
        break;
      case Pathnames.APPOINTMENTS_LIST:
        if (
          !permissions.some((p: Permission) => p.name === "View Appointments")
        )
          return false;
        break;
      case Pathnames.CLIENTS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Clients"))
          return false;
        break;
      case Pathnames.REQUESTS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Requests"))
          return false;
        break;
      case Pathnames.CONTACTS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Messages"))
          return false;
        break;
      case Pathnames.SERVICES_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Services"))
          return false;
        break;
      case Pathnames.FAQ_LIST:
        if (!permissions.some((p: Permission) => p.name === "View FAQs"))
          return false;
        break;
      case Pathnames.ERROR_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Errors"))
          return false;
        break;
      case Pathnames.LOGS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Logs"))
          return false;
        break;
      case Pathnames.USERS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Users"))
          return false;
        break;
      case Pathnames.ESTIMATES_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Estimates"))
          return false;
        break;
      case Pathnames.TEAM_EMPLOYEE_LIST:
      case Pathnames.TEAMS_LIST:
      case Pathnames.EMPLOYEES_LIST:
      case Pathnames.CONTRACTORS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Teams"))
          return false;
        break;
      case Pathnames.PROJECTS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Projects"))
          return false;
        break;
      case Pathnames.ROLES_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Roles"))
          return false;
        break;
      case Pathnames.TAGS_LIST:
      case Pathnames.TAG_GROUPS_LIST:
        if (
          !permissions.some(
            (p: Permission) => p.name === "View Tags and Tag Groups",
          )
        )
          return false;
        break;
      case Pathnames.PERMISSIONS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Permissions"))
          return false;
        break;
      case Pathnames.LOGS_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Logs"))
          return false;
        break;
      case Pathnames.ERROR_LIST:
        if (!permissions.some((p: Permission) => p.name === "View Errors"))
          return false;
        break;
      default:
        break;
    }
    return true;
  };

  return (
    <>
      {loading && <Spinner />}
      <SearchProvider>
        <div className="container" style={customStyles}>
          {allowedPaths() && <Sidebar />}
          <div className="main-area">
            <header className="navbar-content">
              {/* Navbar content */}
              {allowedPaths() && <Navbar />}
            </header>
            <main className="main-content">
              {/* Main content like tables */}
              <Routes>
                <Route path={Pathnames.LOGIN} element={<Login />} />
                <Route
                  path={Pathnames.DASHBOARD}
                  element={
                    checkPathPermission(Pathnames.DASHBOARD) ? (
                      <Dashboard />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.GALLERY_LIST}
                  element={
                    checkPathPermission(Pathnames.GALLERY_LIST) ? (
                      <Gallery />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.REVIEWS_LIST}
                  element={
                    checkPathPermission(Pathnames.REVIEWS_LIST) ? (
                      <Reviews />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.APPOINTMENTS_LIST}
                  element={
                    checkPathPermission(Pathnames.APPOINTMENTS_LIST) ? (
                      <Appointments />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.CLIENTS_LIST}
                  element={
                    checkPathPermission(Pathnames.CLIENTS_LIST) ? (
                      <Clients />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.REQUESTS_LIST}
                  element={
                    checkPathPermission(Pathnames.REQUESTS_LIST) ? (
                      <Requests />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.CONTACTS_LIST}
                  element={
                    checkPathPermission(Pathnames.CONTACTS_LIST) ? (
                      <Contacts />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.SERVICES_LIST}
                  element={
                    checkPathPermission(Pathnames.SERVICES_LIST) ? (
                      <Services />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.FAQ_LIST}
                  element={
                    checkPathPermission(Pathnames.FAQ_LIST) ? (
                      <Faqs />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.ERROR_LIST}
                  element={
                    checkPathPermission(Pathnames.ERROR_LIST) ? (
                      <Errors />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.LOGS_LIST}
                  element={
                    checkPathPermission(Pathnames.LOGS_LIST) ? (
                      <Logs />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.USERS_LIST}
                  element={
                    checkPathPermission(Pathnames.USERS_LIST) ? (
                      <Users />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.ESTIMATES_LIST}
                  element={
                    checkPathPermission(Pathnames.ESTIMATES_LIST) ? (
                      <Estimates />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_LIST}
                  element={
                    checkPathPermission(Pathnames.PRODUCTS_SERVICES_LIST) ? (
                      <Overview />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_BUNDLE_LIST}
                  element={
                    checkPathPermission(
                      Pathnames.PRODUCTS_SERVICES_BUNDLE_LIST,
                    ) ? (
                      <Overview />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_CATEGORY_LIST}
                  element={
                    checkPathPermission(
                      Pathnames.PRODUCTS_SERVICES_CATEGORY_LIST,
                    ) ? (
                      <Overview />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_VENDOR_LIST}
                  element={
                    checkPathPermission(
                      Pathnames.PRODUCTS_SERVICES_VENDOR_LIST,
                    ) ? (
                      <Overview />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route path={Pathnames.PROFILE} element={<UserProfile />} />
                <Route
                  path={Pathnames.TEAM_EMPLOYEE_LIST}
                  element={
                    checkPathPermission(Pathnames.TEAM_EMPLOYEE_LIST) ? (
                      <OverviewTeam />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.TEAMS_LIST}
                  element={
                    checkPathPermission(Pathnames.TEAMS_LIST) ? (
                      <OverviewTeam />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.EMPLOYEES_LIST}
                  element={
                    checkPathPermission(Pathnames.EMPLOYEES_LIST) ? (
                      <OverviewTeam />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PROJECTS_LIST}
                  element={
                    checkPathPermission(Pathnames.PROJECTS_LIST) ? (
                      <Projects />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.ACTIVATE_ACCOUNT}
                  element={<ActivationAccount />}
                />
                <Route
                  path={Pathnames.ROLES_LIST}
                  element={
                    checkPathPermission(Pathnames.ROLES_LIST) ? (
                      <Roles />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route path={Pathnames.SETTINGS} element={<Settings />} />
                <Route
                  path={Pathnames.CONTRACTORS_LIST}
                  element={
                    checkPathPermission(Pathnames.CONTRACTORS_LIST) ? (
                      <OverviewTeam />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.TAGS_LIST}
                  element={
                    checkPathPermission(Pathnames.TAGS_LIST) ? (
                      <OverviewTag />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.TAG_GROUPS_LIST}
                  element={
                    checkPathPermission(Pathnames.TAG_GROUPS_LIST) ? (
                      <OverviewTag />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                <Route
                  path={Pathnames.PERMISSIONS_LIST}
                  element={
                    checkPathPermission(Pathnames.PERMISSIONS_LIST) ? (
                      <Permissions />
                    ) : (
                      <DeniedAccess />
                    )
                  }
                />
                {/* <Route path={Pathnames.EMAIL_LIST} element={< />} />
              <Route path={Pathnames.MESSAGE_LIST} element={< />} /> */}
              </Routes>
            </main>
          </div>
        </div>
      </SearchProvider>
    </>
  );
};

export default Admin;
